import React from 'react';
import pt from 'prop-types';

import HelpLink from 'components/help-link';

import './section-header.scss';

export default class SectionHeader extends React.PureComponent {
  static propTypes = {
    className: pt.string,
    helpLink: pt.bool,
    title: pt.string.isRequired,
    titleIcon: pt.node,
    image: pt.node,
    subtitle: pt.node,
    count: pt.number,
  };

  render() {
    const {
      className,
      helpLink,
      title,
      titleIcon,
      image,
      subtitle,
      count,
      ...props
    } = this.props;

    return (
      <div className="section-header">
        {image && <div className="section-header-image">{image}</div>}

        <div className="section-header-content">
          <div className="section-side-help-link">
            <h3 className={className}>
              {count > 0 ? (
                <div className="section-title-count">
                  {title} <span className="section-title-badge">{count}</span>
                </div>
              ) : (
                <>
                  {titleIcon} {title}
                </>
              )}
            </h3>

            {!subtitle && helpLink !== false && (
              <HelpLink sectionName={title.toString()} {...props} />
            )}
          </div>

          {subtitle && (
            <div className="section-side-help-link">
              <p>{subtitle}</p>

              {helpLink !== false && (
                <HelpLink sectionName={title.toString()} {...props} />
              )}
            </div>
          )}
        </div>
      </div>
    );
  }
}
